// ip-header.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IpService } from '../../services/ip-service.service';

@Injectable()
export class IpHeaderInterceptor implements HttpInterceptor {

  constructor(private ipService: IpService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Skip the ipify call itself — avoid infinite loop
    if (req.url.includes('ipify.org')) {
      return next.handle(req);
    }

    return this.ipService.getIPAddress().pipe(  // ← cached via shareReplay(1), no extra HTTP call
      switchMap(ip => {
        const cloned = req.clone({
          setHeaders: {
            'X-Forwarded-For': ip   // ← header name YARP will read
          }
        });
        return next.handle(cloned);
      })
    );
  }
}
